import { render, staticRenderFns } from "./PosSupplier.vue?vue&type=template&id=2986f5a3&"
import script from "./PosSupplier.vue?vue&type=script&lang=js&"
export * from "./PosSupplier.vue?vue&type=script&lang=js&"
import style0 from "./PosSupplier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports